// Global Instructions Rule Applied!
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'
import { MENU_ITEM_KEY_TRANCHES, REPORT_CONFIG_NAME_TRANCHES } from '../globals.ts'
import { resolveReportIdForMenuItem } from '../utils/reportingGridColumns.ts'

/** `reporting_config.id` for the Tranches grid column layout (from global configs). */
export function useTranchesReportId(): string | undefined {
  const menuItems = useSelector((state: RootState) => state.globalConfigs?.menu_items ?? [])
  const reportingConfigs = useSelector((state: RootState) => state.globalConfigs?.reporting_configs ?? [])

  return useMemo(
    () =>
      resolveReportIdForMenuItem(reportingConfigs, menuItems, MENU_ITEM_KEY_TRANCHES, REPORT_CONFIG_NAME_TRANCHES),
    [menuItems, reportingConfigs]
  )
}
